/**
 * Data hook for the Operations Rejected surface.
 *
 *   useRejected() — polls GET /api/rejected every 60s. Read-only; matters enter
 *   the rejected book upstream (Airtable/the portal/n8n) when routing exhausts.
 *
 * Polls at 60s, matching Closed — both are terminal graveyards. A rejected
 * matter never changes, and new arrivals trickle in over days; there is nothing
 * to gain from a tight refresh. The payload is bounded server-side to the recent
 * window, so the poll is one page no matter how large the archive grows.
 *
 * Spec: engineering/command-center/docs/port-notes/rejected.md (evicted 2026-08-29, #775 round 10)
 */

import { RejectedResponseSchema } from "@command-center/shared";
import { createPollingQuery } from "./create-polling-query";

export const useRejected = createPollingQuery({
  queryKey: ["rejected"] as const,
  path: "/api/rejected",
  schema: RejectedResponseSchema,
  refetchIntervalMs: 60_000,
});
